import axios from "axios";
import { useMemo } from "react";
import { useQuery } from "react-query";

import { CompanyInventoryDetailsResponse, TransactionMaterial } from "../types";

const getCompanyInventory = (companyId: number) =>
  axios
    .get<CompanyInventoryDetailsResponse>("storages/getStoragesForCompany", {
      params: { companyId },
    })
    .then((res) => res.data);

const useWarehouseMaterials = (companyId: number, warehouseId: number) => {
  const { data: companyInventory, isFetching } = useQuery(
    ["companyInventory", companyId],
    () => getCompanyInventory(companyId)
  );

  const data: TransactionMaterial[] = useMemo(
    () =>
      companyInventory?.storages.find((s) => s.storageId === warehouseId)
        ?.materials || [],
    [companyInventory, warehouseId]
  );

  return { data, isFetching };
};

export default useWarehouseMaterials;
